"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ComponentWithBodyClass;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var forEachClassName = function forEachClassName(classNames, cb) {
  classNames.trim().split(/\s+/).forEach(function (className) {
    cb(className);
  });
};
/**
 * Passes the child component through directly, while toggling
 * the body class according to the bodyClassName prop
 */


function ComponentWithBodyClass(props) {
  var bodyElement = props.bodyElement,
      bodyClassName = props.bodyClassName,
      children = props.children;
  (0, _react.useEffect)(function () {
    forEachClassName(bodyClassName, function (className) {
      bodyElement.classList.add(className);
    });
    return function () {
      forEachClassName(bodyClassName, function (className) {
        bodyElement.classList.remove(className);
      });
    };
  }, [bodyClassName, bodyElement]);
  return children;
}

ComponentWithBodyClass.propTypes = {
  bodyClassName: _propTypes.default.string.isRequired,
  bodyElement: _propTypes.default.object.isRequired,
  children: _propTypes.default.node
};
ComponentWithBodyClass.defaultProps = {
  bodyElement: document.body
};
ComponentWithBodyClass.displayName = 'ComponentWithBodyClass';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/utils/ComponentWithBodyClass.js
// module id = 512
// module chunks = 5 6